import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: '',
        component: () => import('../views/public/HomeAppView.vue')
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('../views/public/HomeView.vue')
    },
    {
        path: "/login",
        name: "Login",
        component: () => import("../views/public/LoginView.vue"),
    },
    {
        path: '/public-profil',
        name: 'PublicProfil',
        component: () => import('@/views/public/profil/ProfilMainView.vue')
    },
    {
        path: '/public-visi-misi',
        name: 'PublicVisiMisi',
        component: () => import('@/views/public/profil/ProfilVisiMisiView.vue')
    },
    {
        path: '/public-tugas',
        name: 'PublicTugas',
        component: () => import('@/views/public/profil/ProfilTugasView.vue')
    },
    {
        path: '/public-struktur',
        name: 'PublicStruktur',
        component: () => import('@/views/public/profil/ProfilStrukturView.vue')
    },
    {
        path: '/public-profil-pegawai/:id',
        name: 'PublicProfilPegawai',
        component: () => import('@/views/public/profil/ProfilPegawaiView.vue')
    },
    {
        path: '/public-regulasi',
        name: 'PublicRegulasi',
        component: () => import('@/views/public/profil/ProfilRegulasiView.vue')
    },
    {
        path: '/public-sop',
        name: 'PublicSop',
        component: () => import('@/views/public/e-library/DokumenSopView.vue')
    },
    {
        path: '/public-galeri',
        name: 'PublicGaleri',
        component: () => import('@/views/public/profil/ProfilGaleriView.vue')
    },
    {
        path: '/public-manajemen-talenta',
        name: 'PublicManajemenTalenta',
        component: () => import('@/views/public/profil/ProfilManajemenTalentaView.vue')
    },
    {
        path: '/public-dpmd-masa',
        name: 'PublicDpmdMasaKeMasa',
        component: () => import('@/views/public/profil/DpmdMasaKeMasaView.vue')
    },
    {
        path: '/public-statistik-pegawai',
        name: 'PublicStatistikPegawai',
        component: () => import('@/views/public/profil/StatistikPegawaiView.vue')
    },
    {
        path: '/public-gallery-detail/:id',
        name: 'GalleryDetilView',
        component: () =>
            import ('../views/public/profil/GalleryDetilView.vue')
    },
    {
        path: '/public-berita',
        name: 'PublicBerita',
        component: () => import('../views/public/berita/BeritaView.vue')
    },
    {
        path: '/public-berita-detail/:id',
        name: 'PublicBeritaDetail',
        component: () => import('../views/public/berita/BeritaDetailView.vue')
    },
    {
        path: '/public-ppid',
        name: 'PublicPpid',
        component: () => import('../views/public/ppid/PpidMainView.vue')
    },
    {
        path: '/public-informasi-setiap-saat',
        name: 'InformasiSetiapSaat',
        component: () => import('../views/public/ppid/InformasiSetiapSaatView.vue')
    },
    {
        path: '/public-informasi-berkala',
        name: 'InformasiBerkala',
        component: () => import('../views/public/ppid/InformasiBerkalaView.vue')
    },
    {
        path: '/public-informasi-serta-merta',
        name: 'InformasiSertaMerta',
        component: () => import('../views/public/ppid/InformasiSertaMertaView.vue')
    },
    {
        path: '/public-informasi-dikecualikan',
        name: 'InformasiDikecualikan',
        component: () => import('../views/public/ppid/InformasiDikecualikanView.vue')
    },
    {
        path: '/public-layanan',
        name: 'PublicLayanan',
        component: () => import('../views/public/layanan/LayananView.vue')
    },
    {
        path: '/public-saran',
        name: 'PublicSaran',
        component: () => import('../views/public/saran/SaranView.vue')
    },
    {
        path: '/public-konsultasi',
        name: 'PublicKonsultasi',
        component: () => import('../views/public/lilin-desa/KonsultasiView.vue')
    },
    {
        path: '/public-daftar-survey',
        name: 'PublicSurveyList',
        component: () => import('../views/public/survey/SurveyListView.vue')
    },
    {
        path: '/public-survey',
        redirect: '/public-daftar-survey'
    },
    {
        path: '/public-survey/:id',
        name: 'PublicSurvey',
        component: () => import('../views/public/survey/SurveyView.vue')
    },
    {
        path: '/public-survey-question',
        name: 'PublicSurveyQuestion',
        component: () => import('../views/public/survey/SurveyQuestionView.vue')
    },
    {
        path: '/public-e-library',
        name: 'PublicElibrary',
        component: () => import('../views/public/e-library/ElibraryView.vue')
    },
    {
        path: '/public-e-library-detil/:id',
        name: 'PublicLibraryDetail',
        component: () =>
            import ('../views/public/e-library/ElibraryDetailView.vue')
    },
    {
        path: '/public-produk-hukum',
        name: 'PublicProdukHukum',
        component: () => import('../views/public/e-library/ProdukHukumView.vue')
    },
    {
        path: '/public-arsip/:id',
        name: 'PublicArsip',
        component: () =>
            import ('../views/public/e-library/DokumenPerencanaanView.vue')
    },
    {
        path: '/statistik-dashboard',
        name: 'StatistikDashboard',
        component: () =>
            import ('../views/user/StatistikDashboardView.vue')
    },
    {
        path: '/sebaran-skor-indikator',
        name: 'IndexIndicatorDetail',
        component: () =>
            import ('../views/user/IndexDimensionDetailView.vue')
    },
    {
        path: '/skor-per-desa/:desaId',
        name: 'SkorPerDesa',
        component: () =>
            import ('../views/user/SkorPerDesaView.vue')
    },
    {
        path: '/peta-interaktif',
        name: 'PetaInteraktif',
        component: () =>
            import ('../views/user/PetaInteraktifView.vue')
    },
    {
        path: '/data-per-desa/:desaName',
        name: 'DataPerDesa',
        component: () =>
            import ('../views/user/DataPerDesaView.vue')
    },


    // ADMIN
    {
        path: '/dashboard-utama',
        name: 'DashboardUtama',
        component: () => import('../views/admin/dashboard/DashboardView.vue')
    },
    {
        path: '/admin-dashboard-f-header-item',
        name: 'AdminDashboardFHeaderItemView',
        component: () => import('../views/admin/data-dashboard/DashboardFHeaderItemView.vue')
    },
    {
        path: '/admin-dashboard-f-data-item',
        name: 'AdminDashboardFDataItemView',
        component: () => import('../views/admin/data-dashboard/DashboardFDataItemView.vue')
    },
    {
        path: '/admin-dashboard-f-report-group',
        name: 'AdminDashboardFReportGroupView',
        component: () => import('../views/admin/data-dashboard/DashboardFReportGroupView.vue')
    },
    {
        path: '/admin-dashboard-f-dimensi',
        name: 'AdminDashboardFDimensiView',
        component: () => import('../views/admin/data-dashboard/DashboardFDimensiView.vue')
    },
    {
        path: '/admin-dashboard-f-sub-dimensi',
        name: 'AdminDashboardFSubDimensiView',
        component: () => import('../views/admin/data-dashboard/DashboardFSubDimensiView.vue')
    },
    {
        path: '/admin-dashboard-f-perangkat-indikator',
        name: 'AdminDashboardFPerangkatIndikatorView',
        component: () => import('../views/admin/data-dashboard/DashboardFPerangkatIndikatorView.vue')
    },
    {
        path: '/admin-dashboard-f-indikator',
        name: 'AdminDashboardFIndikatorView',
        component: () => import('../views/admin/data-dashboard/DashboardFIndikatorView.vue')
    },
    {
        path: '/admin-seed-indikator',
        name: 'AdminSeedIndikatorView',
        component: () => import('../views/admin/data-dashboard/AdminSeedIndikatorView.vue')
    },
    {
        path: '/admin-dashboard-f-klassifikasi',
        name: 'AdminDashboardFKlassifikasiView',
        component: () => import('../views/admin/data-dashboard/DashboardFKlassifikasiView.vue')
    },
    {
        path: '/admin-dashboard-ft-skor',
        name: 'AdminDashboardFtSkorView',
        component: () => import('../views/admin/data-dashboard/DashboardFtSkorView.vue')
    },
    {
        path: '/admin-dashboard-header-detil',
        name: 'AdminDashboardHeaderDetilView',
        component: () => import('../views/admin/data-dashboard/DashboardHeaderDetilView.vue')
    },
    {
        path: '/admin-dashboard-header-detil/:ftDataHeaderId',
        name: 'AdminDashboardHeaderDetilDetilView',
        component: () => import('../views/admin/data-dashboard/DashboardHeaderDetilDetilView.vue'),
        props: true
    },
    {
        path: '/admin-dashboard-ft-data-header',
        redirect: '/admin-dashboard-header-detil'
    },
    {
        path: '/admin-dashboard-ft-data-detil',
        redirect: '/admin-dashboard-header-detil'
    },
    {
        path: '/admin-data-peta-dataset',
        name: 'AdminDataPetaDatasetView',
        component: () => import('../views/admin/data-peta/DataPetaDatasetView.vue')
    },
    {
        path: '/admin-data-peta-region',
        name: 'AdminDataPetaRegionView',
        component: () => import('../views/admin/data-peta/DataPetaRegionView.vue')
    },
    {
        path: '/admin-data-peta-area',
        name: 'AdminDataPetaAreaView',
        component: () => import('../views/admin/data-peta/DataPetaAreaView.vue')
    },
    {
        path: '/admin-data-peta-sub-area',
        name: 'AdminDataPetaSubAreaView',
        component: () => import('../views/admin/data-peta/DataPetaSubAreaView.vue')
    },
    {
        path: '/admin-survei',
        name: 'AdminSurveiView',
        component: () => import('../views/admin/survei/SurveiResultView.vue')
    },
    {
        path: '/admin-survei-summary/:ftTesId',
        name: 'AdminSurveiSummaryView',
        component: () => import('../views/admin/survei/SurveiResultSummaryView.vue'),
        props: true
    },
    {
        path: '/admin-struktur-organisasi',
        name: 'AdminStrukturOrganisasi',
        component: () => import('../views/admin/profil-dinas/StrukturOrganisasiView.vue')
    },
    {
        path: '/admin-profil-pegawai',
        name: 'AdminProfilPegawai',
        component: () => import('../views/admin/pegawai/ProfilPegawaiView.vue')
    },
    {
        path: '/admin-dpmd-masa',
        name: 'AdminDpmdMasa',
        component: () => import('../views/admin/pegawai/DpmdMasaKeMasaView.vue')
    },
    {
        path: '/admin-profil-dinas',
        name: 'AdminProfilDinas',
        component: () => import('../views/admin/profil-dinas/ProfilDinasView.vue')
    },
    {
        path: '/admin-visi-misi',
        name: 'AdminVisiMisi',
        component: () => import('../views/admin/profil-dinas/VisiMisiView.vue')
    },
    {
        path: '/admin-sop',
        name: 'AdminSop',
        component: () => import('../views/admin/profil-dinas/SopPelayananView.vue')
    },
    {
        path: '/admin-tugas-fungsi',
        name: 'AdminTugasFungsi',
        component: () => import('../views/admin/profil-dinas/TugasFungsiView.vue')
    },
    {
        path: '/admin-peraturan-regulasi',
        name: 'AdminPeraturanRegulasi',
        component: () => import('../views/admin/profil-dinas/PeraturanRegulasiView.vue')
    },
    {
        path: '/admin-galeri',
        name: 'AdminGaleriView',
        component: () => import('../views/admin/profil-dinas/GaleriView.vue')
    },
    {
        path: '/admin-manajemen-talenta',
        name: 'AdminManajemenTalenta',
        component: () => import('../views/admin/profil-dinas/ManajemenTalentaView.vue')
    },
    {
        path: '/admin-golongan',
        name: 'AdminGolongan',
        component: () => import('../views/admin/pegawai/GolonganView.vue')
    },
    {
        path: '/admin-berita-agenda',
        name: 'AdminBeritaAgenda',
        component: () => import('../views/admin/berita/BeritaAgendaView.vue')
    },
    {
        path: '/admin-sistem',
        name: 'AdminSistem',
        component: () => import('../views/admin/setting/UserView.vue')
    },
    {
        path: '/admin-struktur-organisasi-sistem',
        name: 'AdminStrukturSistem',
        component: () => import('../views/admin/setting/StrukturSistemView.vue')
    },
    {
        path: '/admin-ppid',
        name: 'AdminPpid',
        component: () => import('../views/admin/ppid/PpidView.vue')
    },
    {
        path: '/admin-kumpulan-informasi',
        name: 'AdminInformasi',
        component: () => import('../views/admin/ppid/InformasiView.vue')
    },
    {
        path: '/admin-permohonan-informasi',
        name: 'AdminPermohonanInformasi',
        component: () => import('../views/admin/layanan/PermohonanInformasiView.vue')
    },
    {
        path: '/admin-pengajuan-keberatan',
        name: 'AdminPengajuanKeberatan',
        component: () => import('../views/admin/layanan/PengajuanKeberatanView.vue')
    },
    {
        path: '/admin-penyelesaian-sengketa',
        name: 'AdminPenyelesaianSengketa',
        component: () => import('../views/admin/layanan/PenyelesaianSengketaView.vue')
    },
    {
        path: '/admin-app-link',
        name: 'AdminAppLink',
        component: () => import('../views/admin/setup/AppView.vue')
    },
    {
        path: '/admin-saran',
        name: 'AdminSaran',
        component: () => import('../views/admin/saran/SaranView.vue')
    },
    {
        path: '/admin-konsultasi',
        name: 'AdminKonsultasi',
        component: () => import('../views/admin/konsultasi/KonsultasiView.vue')
    },

    {
        path: '/admin-din-carousel',
        name: 'AdminDinCarousel',
        component: () => import('../views/admin/setup/DinCarouselView.vue')
    },
    {
        path: '/admin-soal',
        name: 'AdminSoal',
        component: () => import('../views/admin/survei/SoalView.vue')
    },
    {
        path: '/admin-template-survei',
        name: 'AdminTes',
        component: () => import('../views/admin/survei/TesView.vue')
    },

    // ADMIN E-LIBRARY
    {
        path: '/admin-arsip-categ',
        name: 'AdminArsipCateg',
        component: () => import('../views/admin/e-library/ArticleCategView.vue')
    },
    {
        path: '/admin-arsip',
        name: 'AdminArsip',
        component: () => import('../views/admin/e-library/ArticleView.vue')
    },





    {
        path: '/public-desa-presisi',
        name: 'PublicDesaPresisi',
        component: () => import('../views/public/desa-presisi/DesaPresisiView.vue')
    },
    {
        path: '/public-lilin-desa',
        name: 'PublicLilinDesa',
        component: () => import('../views/public/lilin-desa/HomeLilinDesaView.vue')
    },
    {
        path: '/public-pemuda-desa',
        name: 'PublicPemudaDesa',
        component: () => import('../views/public/HomePemudaDesaView.vue')
    },

];

const router = createRouter({
    // Ganti BASE_URL dengan process.env.BASE_URL
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
